import { CategoryType } from "./category.type";

export enum AssignmentSource {
  AI_SUGGESTED = "AI_SUGGESTED",
  SIMBUY_ASSIGNED = "SIMBUY_ASSIGNED",
  MANUAL = "MANUAL",
  OFFER_BASED = "OFFER_BASED",
}

export interface CategorySuggestionResponse {
  categoryId: string;
  categoryName: string;
  categoryNameEn: string;
  categoryType: CategoryType;
  confidenceScore: number; // 0..1
  rationale: string;
  alreadyAssigned: boolean;
}

export interface CategoryFilterResponse {
  categoryId: string;
  categoryName: string;
  categoryNameEn: string;
  categoryType: CategoryType;
  materialCount: number;
  isAssignedToSupplier: boolean;
}

export interface SupplierCategoryAssignmentResponse {
  assignmentId: string;
  categoryId: string;
  categoryName: string;
  categoryNameEn: string;
  categoryType: CategoryType;
  source: AssignmentSource;
  confidenceScore?: number;
  aiRationale?: string;
  active: boolean;
  assignedAt: string; // ISO
}

export interface SupplierCategoryAnalysisResponse {
  supplierSummary: string;
  indirectGoodsSuggestions: CategorySuggestionResponse[];
  directGoodsSuggestions: CategorySuggestionResponse[];
  servicesSuggestions: CategorySuggestionResponse[];
  analysisRationale: string;
}

export interface AssignCategoriesRequest {
  categoryIds: string[];
  reason?: string;
}

export interface AssignCategoriesResponse {
  message: string;
}
